import React from 'react';
import { Link } from 'react-router-dom';
import Axios from 'axios';
import Alertify from 'alertifyjs';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import Core from './funciones_extras';
import Citas from './citas_c';
import User from '../user_profile.png';
import '../css/gestion-pacientes.css';

function fechaParaInput(valor) {
    if (!valor) return '';
    const s = String(valor);
    if (s.length >= 10 && s.indexOf('T') === -1) return s.slice(0, 10);
    if (s.indexOf('T') !== -1) return s.slice(0, 10);
    return s;
}

class ActualizarPaciente extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            estado: '',
            cargando: true,
            guardando: false,
            subiendoFoto: false,
            paciente: {
                doctor: {},
                nombre: '',
                apellido: '',
                cedula: '',
                sexo: 'd',
                fecha_nacimiento: '',
                telefono: '',
                correo_electronico: '',
                nombre_tutor: '',
                id_doctor: '',
                foto_paciente: '',
                es_pediatrico: 'no',
            },
            doctores: [],
            fotoPreview: null,
        };
        this.fotoInputRef = React.createRef();
    }

    getIdPaciente = () => {
        if (this.props.match && this.props.match.params && this.props.match.params.id) {
            return this.props.match.params.id;
        }
        if (this.props.IdPaciente) return this.props.IdPaciente;
        return null;
    };

    componentDidMount() {
        const id = this.getIdPaciente();
        if (id) {
            this.cargar_data_paciente(id);
        } else {
            this.setState({ cargando: false });
            Alertify.error('No se encontró el paciente');
        }
        Core.cargar_doctores(this);
    }

    cargar_data_paciente = (id_paciente) => {
        this.setState({ cargando: true });
        Axios.get(`${Core.url_base}/api/paciente/${id_paciente}`)
            .then((res) => {
                const p = res.data || {};
                const tieneTutor = !!(p.nombre_tutor && String(p.nombre_tutor).trim());
                this.setState({
                    cargando: false,
                    paciente: {
                        ...p,
                        doctor: p.doctor || {},
                        sexo: p.sexo || 'd',
                        fecha_nacimiento: fechaParaInput(p.fecha_nacimiento),
                        id_doctor: p.id_doctor != null ? String(p.id_doctor) : '',
                        es_pediatrico: tieneTutor ? 'si' : 'no',
                    },
                    fotoPreview: Core.url_storage_publico(p.foto_paciente) || null,
                });
            })
            .catch(() => {
                this.setState({ cargando: false });
                Alertify.error('Error al cargar paciente');
            });
    };

    abrirSelectorFoto = () => {
        if (this.fotoInputRef.current) this.fotoInputRef.current.click();
    };

    cambiar_foto = (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;

        const id = this.getIdPaciente();
        const formData = new FormData();
        formData.append('foto_paciente', file);
        formData.append('id', id);

        const previewUrl = URL.createObjectURL(file);
        this.setState({ fotoPreview: previewUrl, subiendoFoto: true });

        Axios.post(`${Core.url_base}/api/actualizar_foto_paciente`, formData)
            .then((res) => {
                const url = Core.url_storage_publico(res.data);
                if (url) {
                    this.setState((prev) => ({
                        fotoPreview: url,
                        subiendoFoto: false,
                        paciente: { ...prev.paciente, foto_paciente: res.data },
                    }));
                    Alertify.success('Foto actualizada');
                } else {
                    this.setState({ subiendoFoto: false });
                }
            })
            .catch(() => {
                this.setState({ subiendoFoto: false });
                Alertify.error('No se pudo subir la foto');
            });
    };

    actualizarCampo = (e) => {
        const { id, value, type, checked } = e.target;
        this.setState((prev) => {
            const paciente = { ...prev.paciente, [id]: type === 'checkbox' ? (checked ? 'si' : 'no') : value };
            if (id === 'es_pediatrico' && value === 'no') {
                paciente.nombre_tutor = '';
            }
            return { paciente };
        });
    };

    setTelefono = (valor) => {
        this.setState((prev) => ({
            paciente: { ...prev.paciente, telefono: valor || '' },
        }));
    };

    actualizar = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const { paciente } = this.state;
        const id = this.getIdPaciente();

        if (!paciente.nombre || !paciente.nombre.trim()) {
            Alertify.warning('El nombre es obligatorio');
            return;
        }
        if (!paciente.apellido || !paciente.apellido.trim()) {
            Alertify.warning('El apellido es obligatorio');
            return;
        }
        if (!paciente.id_doctor) {
            Alertify.warning('Seleccione el doctor asignado');
            return;
        }
        if (paciente.es_pediatrico === 'si' && !(paciente.nombre_tutor || '').trim()) {
            Alertify.warning('Indique el nombre del tutor');
            return;
        }

        const paciente_update = {
            nombre: paciente.nombre.trim(),
            apellido: paciente.apellido.trim(),
            cedula: paciente.cedula || '',
            sexo: paciente.sexo,
            fecha_nacimiento: paciente.fecha_nacimiento || '',
            id_doctor: paciente.id_doctor,
            telefono: paciente.telefono || '',
            correo_electronico: paciente.correo_electronico || '',
            nombre_tutor: paciente.es_pediatrico === 'si' ? (paciente.nombre_tutor || '').trim() : '',
            id,
        };

        this.setState({ guardando: true });
        Axios.post(`${Core.url_base}/api/actualizar_paciente`, paciente_update)
            .then(() => {
                Alertify.success('Paciente actualizado correctamente');
                this.setState({ guardando: false, estado: 'pacientes' });
            })
            .catch(() => {
                this.setState({ guardando: false });
                Alertify.error('Error al actualizar paciente');
            });
    };

    ver_pacientes = () => {
        this.setState({ estado: 'pacientes' });
    };

    renderField = (id, label, optional, children) => (
        <div className="col-md-6 agregar-paciente-field">
            <label htmlFor={id} className="agregar-paciente-label">
                {label}
                {optional && <span className="agregar-paciente-label-optional"> (opcional)</span>}
            </label>
            {children}
        </div>
    );

    render() {
        if (this.state.estado === 'pacientes') {
            return <Citas />;
        }

        const { paciente, cargando, guardando, subiendoFoto, doctores, fotoPreview } = this.state;
        const lang = (Core.lenguaje && Core.lenguaje.paciente_admin) || {};
        const iniciales = `${(paciente.nombre || '?').charAt(0)}${(paciente.apellido || '').charAt(0)}`.toUpperCase();
        const fotoSrc = fotoPreview || Core.url_storage_publico(paciente.foto_paciente) || User;

        return (
            <div className="col-12 col-md-10 listado-pacientes-page agregar-paciente-page kadosh-form-page">
                <div className="listado-pacientes-hero">
                    <div className="listado-pacientes-hero-info">
                        <div className="listado-pacientes-hero-icon">
                            <i className="fas fa-user-edit" />
                        </div>
                        <div>
                            <h1 className="listado-pacientes-hero-title">Actualizar paciente</h1>
                            <p className="listado-pacientes-hero-subtitle">
                                Modifica los datos del expediente y la asignación médica
                            </p>
                            <div className="agregar-paciente-nav">
                                <button
                                    type="button"
                                    className="agregar-paciente-nav-link agregar-paciente-nav-link--ghost"
                                    onClick={this.ver_pacientes}
                                >
                                    <i className="fas fa-arrow-left" />
                                    Volver a pacientes
                                </button>
                                {this.getIdPaciente() && (
                                    <Link
                                        to={`/perfil_paciente/${this.getIdPaciente()}`}
                                        className="agregar-paciente-nav-link agregar-paciente-nav-link--ghost"
                                    >
                                        <i className="fas fa-id-card" />
                                        Ver perfil
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {cargando ? (
                    <div className="agregar-paciente-form-card">
                        <div className="agregar-paciente-form-body text-center py-5">
                            <i className="fas fa-spinner fa-spin fa-2x text-primary mb-3" style={{ color: '#667eea' }} />
                            <p className="text-muted mb-0">Cargando datos del paciente…</p>
                        </div>
                    </div>
                ) : (
                    <div className="agregar-paciente-form-card">
                        <form className="agregar-paciente-form-body" onSubmit={this.actualizar} noValidate>
                            {paciente.doctor && paciente.doctor.nombre && (
                                <div className="agregar-paciente-alert" style={{ background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af' }}>
                                    <i className="fas fa-user-md" />
                                    <span>
                                        Registrado por: <strong>{paciente.doctor.nombre} {paciente.doctor.apellido}</strong>
                                    </span>
                                </div>
                            )}

                            <div className="agregar-paciente-section">
                                <h2 className="agregar-paciente-section-title">
                                    <i className="fas fa-camera" />
                                    Foto del paciente
                                </h2>
                                <div
                                    className="agregar-paciente-foto-zone"
                                    onClick={this.abrirSelectorFoto}
                                    onKeyDown={(ev) => ev.key === 'Enter' && this.abrirSelectorFoto()}
                                    role="button"
                                    tabIndex={0}
                                    aria-label="Cambiar foto del paciente"
                                >
                                    <img
                                        src={fotoSrc}
                                        id="imagen_paciente"
                                        alt=""
                                        className="agregar-paciente-foto-preview"
                                        style={{ borderRadius: '50%', width: 96, height: 96 }}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = User;
                                        }}
                                    />
                                    <div className="agregar-paciente-foto-text">
                                        <strong>{subiendoFoto ? 'Subiendo foto…' : 'Cambiar foto'}</strong>
                                        <span>JPG o PNG · se guarda al seleccionar</span>
                                    </div>
                                    <input
                                        type="file"
                                        ref={this.fotoInputRef}
                                        id="foto_perfil"
                                        className="agregar-paciente-foto-input"
                                        accept="image/*"
                                        onChange={this.cambiar_foto}
                                    />
                                </div>
                            </div>

                            <div className="agregar-paciente-section">
                                <h2 className="agregar-paciente-section-title">
                                    <i className="fas fa-id-card" />
                                    Datos personales
                                </h2>
                                <div className="row">
                                    {this.renderField('nombre', lang.nombre || 'Nombre', false,
                                        <input
                                            type="text"
                                            id="nombre"
                                            className="agregar-paciente-input form-control"
                                            value={paciente.nombre || ''}
                                            onChange={this.actualizarCampo}
                                            autoComplete="given-name"
                                            required
                                        />
                                    )}
                                    {this.renderField('apellido', lang.apellido || 'Apellido', false,
                                        <input
                                            type="text"
                                            id="apellido"
                                            className="agregar-paciente-input form-control"
                                            value={paciente.apellido || ''}
                                            onChange={this.actualizarCampo}
                                            autoComplete="family-name"
                                            required
                                        />
                                    )}
                                    {this.renderField('cedula', lang.cedula || 'DNI / Cédula', true,
                                        <input
                                            type="text"
                                            id="cedula"
                                            className="agregar-paciente-input form-control"
                                            value={paciente.cedula || ''}
                                            onChange={this.actualizarCampo}
                                        />
                                    )}
                                    {this.renderField('sexo', lang.sexo || 'Sexo', false,
                                        <select
                                            id="sexo"
                                            className="agregar-paciente-select form-control"
                                            value={paciente.sexo || 'd'}
                                            onChange={this.actualizarCampo}
                                        >
                                            <option value="h">Masculino</option>
                                            <option value="m">Femenino</option>
                                            <option value="hm">Hombre moderno</option>
                                            <option value="mm">Mujer moderna</option>
                                            <option value="d">Desconocido</option>
                                        </select>
                                    )}
                                    {this.renderField('fecha_nacimiento', lang.fecha_de_nacimiento || 'Fecha de nacimiento', true,
                                        <input
                                            type="date"
                                            id="fecha_nacimiento"
                                            className="agregar-paciente-input form-control"
                                            value={paciente.fecha_nacimiento || ''}
                                            onChange={this.actualizarCampo}
                                        />
                                    )}
                                </div>

                                <div className="agregar-paciente-pediatrico">
                                    <div className="agregar-paciente-pediatrico-header">
                                        <span className="agregar-paciente-label" style={{ marginBottom: 0 }}>
                                            <i className="fas fa-child" style={{ color: '#667eea', marginRight: 8 }} />
                                            ¿Es pediátrico?
                                        </span>
                                        <label className="agregar-paciente-toggle">
                                            <input
                                                type="checkbox"
                                                id="es_pediatrico"
                                                checked={paciente.es_pediatrico === 'si'}
                                                onChange={(ev) => this.setState((prev) => ({
                                                    paciente: {
                                                        ...prev.paciente,
                                                        es_pediatrico: ev.target.checked ? 'si' : 'no',
                                                        nombre_tutor: ev.target.checked ? prev.paciente.nombre_tutor : '',
                                                    },
                                                }))}
                                            />
                                            <span className="agregar-paciente-toggle-track" />
                                            <span className="agregar-paciente-toggle-thumb" />
                                        </label>
                                    </div>
                                    {paciente.es_pediatrico === 'si' && (
                                        <div className="agregar-paciente-field" style={{ marginTop: 16, marginBottom: 0 }}>
                                            <label htmlFor="nombre_tutor" className="agregar-paciente-label">
                                                Nombre del tutor *
                                            </label>
                                            <input
                                                type="text"
                                                id="nombre_tutor"
                                                className="agregar-paciente-input form-control"
                                                placeholder="Nombre completo del tutor"
                                                value={paciente.nombre_tutor || ''}
                                                onChange={this.actualizarCampo}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="agregar-paciente-section">
                                <h2 className="agregar-paciente-section-title">
                                    <i className="fas fa-address-book" />
                                    Contacto
                                </h2>
                                <div className="row">
                                    <div className="col-md-6 agregar-paciente-field">
                                        <label className="agregar-paciente-label" htmlFor="telefono">
                                            {lang.telefono || 'Teléfono'}
                                        </label>
                                        <div className="agregar-paciente-phone">
                                            <PhoneInput
                                                id="telefono"
                                                defaultCountry="DO"
                                                placeholder="Número de teléfono"
                                                value={paciente.telefono || ''}
                                                onChange={this.setTelefono}
                                                numberInputProps={{ className: 'PhoneInputInput form-control' }}
                                            />
                                        </div>
                                    </div>
                                    {this.renderField('correo_electronico', lang.correo_electronico || 'Correo electrónico', true,
                                        <input
                                            type="email"
                                            id="correo_electronico"
                                            className="agregar-paciente-input form-control"
                                            placeholder="ejemplo@correo.com"
                                            value={paciente.correo_electronico || ''}
                                            onChange={this.actualizarCampo}
                                            autoComplete="email"
                                        />
                                    )}
                                </div>
                            </div>

                            <div className="agregar-paciente-section">
                                <h2 className="agregar-paciente-section-title">
                                    <i className="fas fa-user-md" />
                                    Asignación médica
                                </h2>
                                <div className="row">
                                    <div className="col-md-12 agregar-paciente-field">
                                        <label htmlFor="id_doctor" className="agregar-paciente-label">
                                            Doctor asignado *
                                        </label>
                                        <select
                                            id="id_doctor"
                                            className="agregar-paciente-select form-control"
                                            value={paciente.id_doctor || ''}
                                            onChange={this.actualizarCampo}
                                            required
                                        >
                                            <option value="">Seleccione el doctor</option>
                                            {(doctores || []).map((doc) => (
                                                <option key={doc.id} value={String(doc.id)}>
                                                    {doc.nombre} {doc.apellido}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="agregar-paciente-actions">
                                <button
                                    type="button"
                                    className="agregar-paciente-btn agregar-paciente-btn--ghost"
                                    onClick={this.ver_pacientes}
                                    disabled={guardando}
                                >
                                    <i className="fas fa-times" />
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className="agregar-paciente-btn agregar-paciente-btn--primary"
                                    disabled={guardando}
                                >
                                    {guardando ? (
                                        <><i className="fas fa-spinner fa-spin" /> Guardando…</>
                                    ) : (
                                        <><i className="fas fa-save" /> Actualizar paciente</>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                )}
            </div>
        );
    }
}

export default ActualizarPaciente;
